export default __webpack_public_path__ + "static/media/Träslöjd1.e53d1321.jpeg";